export default "__VITE_ASSET__18fb4be7__"